/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Discipline } from '../../models/discipline';

export interface EdurepControllerGetDisciplines$Params {
}

export function edurepControllerGetDisciplines(http: HttpClient, rootUrl: string, params?: EdurepControllerGetDisciplines$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Discipline>>> {
  const rb = new RequestBuilder(rootUrl, edurepControllerGetDisciplines.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Discipline>>;
    })
  );
}

edurepControllerGetDisciplines.PATH = '/edurep/disciplines';
